const servicesStrings = {
  serviceDetailsContent: {
    addService: 'Add Service',
    editService: 'Edit Service',
    confirmButtonLabel: 'Save',
    cancelButtonLabel: 'Cancel',
    cptCodeFieldLabel: 'CPT Code',
    arabicNameFieldLabel: 'Arabic Name',
    englishNameFieldLabel: 'English Name',
    statusFieldLabel: 'Status',
    categoryFieldLabel: 'Category',
    masterServiceFieldLabel: 'Master Service',
    specialityFieldLabel: 'Speciality',
    specialityFieldPlaceholder: 'Search and Add Speciality',
    arDetailsFieldLabel: 'Arabic Details',
    enDetailsFieldLabel: 'English Details',
    addImage: 'Add Image',
    preparationFieldLabel: 'Preparation',
    preparationFieldPlaceholderAr: 'تحضير',
    addPreparation: 'Add Preparation',
    formFieldErrorText(fieldName) {
      return `${fieldName} field must have a valid value`;
    },
  },
  servicesList: {
    servicesGridHeader: {
      servicesCPTGridHeader: 'CPT',
      servicesNameGridHeader: 'Name',
      servicesPopularGridHeader: 'Popular',
      servicesMasterServiceGridHeader: 'Master Service',
      servicesSpecialityGridHeader: 'Speciality',
      servicesDetailsGridHeader: 'Details',
      servicesPreparationGridHeader: 'Preparation',
      servicesStatusGridHeader: 'Status',
      servicesActionsGridHeader: 'Actions',
    },
    servicesGridNoResultFound: 'No results matching your search criteria',
  },
  servicesFilter: {
    searchBarPlaceholder: 'Search by name or cpt code',
    statusDropdownPlaceholder: 'Select a status',
    specialityDropdownPlaceholder: 'Specialities',
    masterServiceDropdownPlaceholder: 'Master Services',
  },
  serviceDelete: {
    serviceDeleteModalTitle: 'Delete Service',
    serviceDeleteModalConfirmBtn: 'Delete',
    serviceDeleteModalConfirmTitle(service) {
      return (
        <p>
          Are you sure you want to delete <b>{service}</b> service?
        </p>
      );
    },
  },
  alternativeNames: {
    modalTitle: 'Alternatives',
    showAlternativeButton: 'Alternative names',
    unsavedChangesIndicator: 'You have unsaved changes',
    duplicateError: 'This alternative name already exists',
    addAlternativePlaceholder: 'Enter alternative name...',
    addAlternativeButton: 'Add Alternative',
    editButton: 'Edit',
    deleteButton: 'Delete',
    noAlternativesText: 'No alternative names added yet',
    loadingText: 'Loading alternative names...',
    saveButton: 'Save Changes',
    savingButton: 'Saving...',
    cancelButton: 'Cancel',
    saveError: 'Failed to save alternative names',
    loadError: 'Failed to load alternative names',
  },
};

export default servicesStrings;
